import React, { useState } from "react";

const MakeAdmin = () => {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);

  const handleOnBlur = (e) => {
    setEmail(e.target.value);
  };
  const handleAdminSubmit = (e) => {
    const user = { email };
    fetch("https://young-hamlet-12954.herokuapp.com/users/admin", {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(user),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.modifiedCount) {
          console.log(data);
          setSuccess(true);
        }
      });

    e.preventDefault();
  };

  return (
    <div className="signup pt-5 pb-5 mb-5">
      <h2 className="text-center fw-bold">Make Admin</h2>
      <form onSubmit={handleAdminSubmit}>
        <div className="container d-flex flex-column justify-content-center align-items-center">
          <div className="form-floating mb-3 form-div">
            <input
              onBlur={handleOnBlur}
              type="text"
              name="name"
              className="form-control"
              id="floatingInput"
              placeholder="John Doe"
              required
            />
            <label htmlFor="floatingInput">Email</label>
          </div>
          <button className="btn btn-custom w-25 pt-2 pb-2">Make Admin</button>
        </div>
      </form>
      {success && (
        <div className="alert alert-success w-25 d-block mx-auto" role="alert">
          Made admin successfully!
        </div>
      )}
    </div>
  );
};

export default MakeAdmin;
